import { Link, useSearch } from "@tanstack/react-location"
import { useGraphqlQuery } from "graphql-mock"
import { Icon } from "materia"
import { useTranslation } from "react-i18next"
import { modifiers } from "ui-tools"
import { useJourneyNavigation } from "../../tools/useJourneyNavigation"
import { JourneyThumbnail } from "../JourneyThumbnail"
import { query, type Journey } from "./gql"

import s from "./styles.module.scss"

export const JourneyNavigationMobileConnected = () => {
  const { journeyIdParam } = useJourneyNavigation()
  const { data, error, isPending } = useGraphqlQuery(
    query,
    { journeyId: journeyIdParam! },
    { enabled: Boolean(journeyIdParam) }
  )

  const journey = data?.productCategory
  const totalJourneys = data?.productCategories.pageInfo.totalItemCount

  return (
    <JourneyNavigationMobile
      isLoading={isPending}
      error={error}
      journey={journey}
      totalJourneys={totalJourneys}
    />
  )
}

type JourneyNavigationMobileProps = {
  isLoading: boolean
  error: unknown
  journey: Journey | undefined
  totalJourneys: number | undefined
}
export const JourneyNavigationMobile = ({
  isLoading,
  error,
  journey,
  totalJourneys,
}: JourneyNavigationMobileProps) => {
  const { t } = useTranslation()
  const searchParams = useSearch()
  const { backgroundImageUrl, title, isLocked, progress } = journey ?? {}
  const { isCertified } = progress ?? {}

  // If it's done directly in <span/>, Google Translate will crash the app
  const journeysNumberDisplay = isLoading ? "(?)" : `(${totalJourneys})`

  const getJourneyDetails = () => {
    if (isLoading)
      return (
        <>
          <div className={s.navigation__title}>
            <span>{t("journey.YOUR_JOURNEYS")}</span>
            <span className={s.navigation__totalJourneys}>
              {journeysNumberDisplay}
            </span>
          </div>
          <div className={s.skeleton__journeyTitle} />
        </>
      )

    if (error)
      return (
        <>
          <div className={s.navigation__title}>
            <span>{t("journey.YOUR_JOURNEYS")}</span>
          </div>
          <div className={s.navigation__journeyTitle} />
        </>
      )

    return (
      <>
        <div className={s.navigation__title}>
          <span>{t("journey.YOUR_JOURNEYS")}</span>
          <span className={s.navigation__totalJourneys}>
            {journeysNumberDisplay}
          </span>
        </div>
        <div
          className={modifiers(s, "navigation__journeyTitle", {
            isLocked,
            isCertified,
          })}
        >
          {title}
        </div>
      </>
    )
  }

  return (
    <div className={s.navigation}>
      <Link to="list" search={searchParams} className={s.navigation__button}>
        <JourneyThumbnail
          isLocked={isLocked}
          isCertified={isCertified}
          imageUrl={backgroundImageUrl}
        />

        <div className={s.navigation__details}>{getJourneyDetails()}</div>

        <div className={s.navigation__chevron}>
          <Icon icon="Chevron" size="small" />
        </div>
      </Link>
    </div>
  )
}
